import { apiSlice } from "./apiSlice";

export const projectActionpendingApproval = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllProjectActionPendingApproval: builder.query({
            query: (params) => ({
                url: `ProjectActionDateChangeRequest/get`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProjectActionPendingApproval"],
        }),



        createProjectActionPendingApproval: builder.mutation({
            query: (data) => ({
                url: `ProjectActionDateChangeRequest/create`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["ProjectActionPendingApproval"],
        }),

        updateProjectActionPendingApproval: builder.mutation({
            query: (data) => ({
                url: `ProjectActionDateChangeRequest/update-status`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["ProjectActionPendingApproval"],
        }),


    }),
});

export const {
    useCreateProjectActionPendingApprovalMutation,
    useUpdateProjectActionPendingApprovalMutation,
    useLazyGetAllProjectActionPendingApprovalQuery,
    useGetAllProjectActionPendingApprovalQuery
} = projectActionpendingApproval;